var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSymposium)?_c('footer',[_c('p',[_vm._v("COPYRIGHT © "+_vm._s(_vm.baseCurrentYear)+" ADMAN ALL RIGHTS RESERVED. | "),_c('router-link',{attrs:{"to":"/privacy"}},[_vm._v(" PRIVACY POLICY")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }